import React from 'react';
import { translate } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faQuestion, faSyncAlt, faPlay, faStop } from '@fortawesome/pro-solid-svg-icons';
import { classes } from './styles/table';

class StatusCellComponent extends React.Component {

  getVersionString() {
    const { data: { mavenCoordinates } } = this.props;
    if (!mavenCoordinates) {
      return '- NA';
    }
    const split = mavenCoordinates.split(':');
    return ` - ${split[2]}`;
  }

  render() {
    const { t, data } = this.props;
    return (
      <React.Fragment>
        <span className={classes.icon}>
          <FontAwesomeIcon icon={{
            ACTIVE: faBolt,
            STOPPING: faStop,
            STARTED: faPlay,
            UPDATING: faSyncAlt
          }[data.status] || faQuestion} />
        </span>
        {
          t(data.status ? `table.status.${data.status}` : 'table.status.unknown')
        }
        {this.getVersionString() || ''}
      </React.Fragment>
    )
  }

}

export default translate(['comm'])(StatusCellComponent);



// WEBPACK FOOTER //
// ./src/views/comm/status-cell.js